const GST_RATE = 0.15

export function addGST(price: number): number {
  const gst = price * GST_RATE
  const totalPrice = price + gst
  return totalPrice
}

export const getGST = (price: number) => {
  const gst = price * GST_RATE
  return gst
}
